import screenfull from "screenfull";
export function correction() {

    /*document.fullscreenEnabled =
        document.fullscreenEnabled ||
        document.mozFullScreenEnabled ||
        document.documentElement.webkitRequestFullScreen;*/
    /*
        function requestFullscreen(element) {
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            } else if (element.webkitRequestFullScreen) {
                element.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
            }
        }

        if (document.fullscreenEnabled) {
            requestFullscreen(document.documentElement);
        }

        var doc = document.documentElement;
        doc.requestFullscreen();

        window.addEventListener('scoll', function() {
            if (document.fullscreenEnabled) {
                doc.cancelFullSreen();
            }
        })*/
    if (mobilecheck() === true && isMobileDevice() === true) {
        window.scrollTo(0, 1);
        window.addEventListener('load', function () {
            if (screenfull.isEnabled) {
                if (screenfull.isFullscreen == false) {
                    screenfull.request()
                    //screenfull.request().catch();
                    screenfull.on(error => { console.log(error) });
                }
            }
        });

    }
}

function mobilecheck() {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
};

export function isMobileDevice() {
    if (navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)
    ) {
        if (((screen.width >= 480) && (screen.height >= 800)) || ((screen.width >= 800) && (screen.height >= 480)) || navigator.userAgent.match(/ipad/gi)) {
            return true; //'tablette'
        } else if ((screen.width > 1279)) {
            return false;
        } else {
            return true;
        }
    } else {
        return false;
    }
}

export function verifChangeOrientation() {
    if (mobilecheck() === true && isMobileDevice() === true) {
        /*if (screenfull.isEnabled) {
            screenfull.request("body");
        }*/
        window.addEventListener('orientationchange', function (event) {
            if (screenfull.isEnabled && window.orientation == 90) {
                screenfull.request('body');
                screenfull.on('change', () => {
                    console.log('Am I fullscreen?', screenfull.isFullscreen ? 'Yes' : 'No');
                });
                screenfull.on('error', event => {
                    console.error('Failed to enable fullscreen', event);
                });
                console.log('ok');
            } else {
                // Ignore or do something else
            }
        });
    }
}

export function dblclick() {
    window.addEventListener('click', function () {
        if (!Number(this.clicks) || this.clicks == undefined) {
            this.clicks = 0;
        }
        this.clicks++;
        if (this.clicks === 1) {
            this.timer = setTimeout(function () { this.clicks = 0 }, 300);
        }
        //console.log(this.clicks);
        if (screenfull.isEnabled && this.clicks === 2) {
            if (screenfull.isFullscreen == false) {
                screenfull.request()
                //screenfull.request().catch();
                screenfull.on(error => { console.log(error) });
            }
            /* else {
                            screenfull.exit();
                        }*/
            clearTimeout(this.timer);
            this.clicks = 0;
        } else if (this.clicks > 2) {
            this.clicks = 0;
        }
    });
}

export function oneClick() {
    if (screenfull.isEnabled) {
        if (screenfull.isFullscreen == false) {
            screenfull.request();
            //screenfull.request().catch();
            screenfull.on(error => { console.log(error) });
            return 1;
        }
        else {
            screenfull.exit();
            return 0;
        }
    } else {
        screenfull.exit();
        return 0;
    }

}

export function stopRecizeMyScreen() {
    if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i)) {
        console.log('iphone');
    } else {
        if (localStorage.quitAnalyse !== true) {
            if (navigator.userAgent.match(/Android/i)) {
                if (localStorage.hauteurEcran == undefined && localStorage.hauteurEcran == null) {
                    localStorage.hauteurEcran = window.height;
                }
                if (localStorage.largeurEcran == undefined && localStorage.largeurEcran == null) {
                    localStorage.largeurEcran = window.width;
                }
                window.onresize = function () {
                    if (localStorage.hauteurEcran !== undefined && localStorage.hauteurEcran !== null && localStorage.hauteurEcran !== 'undefined') {
                        //screen.height = localStorage.hauteurEcran;

                        if (localStorage.largeurEcran !== undefined && localStorage.largeurEcran !== null && localStorage.largeurEcran !== 'undefined') {
                            console.log(localStorage.hauteurEcran, localStorage.largeurEcran);
                            let body = document.getElementById('app');
                            body.style.overflowY = 'scroll';
                        }
                    }
                }
                console.log(localStorage.hauteurEcran, localStorage.largeurEcran)
            }
        }

    }
}

export function detectSafari() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') != -1) {
        if (ua.indexOf('chrome') > -1) {
            return false;
        } else {
            return true;
        }
    }
}


// WEBPACK FOOTER //
// ./src/controller/correctionEcran.js